// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ncdg","right":"styles_right__L43Yw"};